import { commonSelectors } from "../selector-template-generator";

export const patientsDocumentsConfig = {
  fields: [
    {
      name: "start",
      label: "Start",
      hide: true,
    },
    {
      name: "documents",
      label: "Documents",
      type: "subform:multiple",
      props: { add: true, delete: true },
      subFormFields: [
        {
          name: "document",
          label: "Document",
          type: "file",
          required: true,
          accept: ".pdf,.doc,.docx,.jpg,.jpeg,.png",
        },
        {
          name: "name",
          label: "Document Name",
          type: "text",
          pattern: "^[A-Za-z]+( [A-Za-z]+)*$",
          required: true,
        },
        {
          name: "date",
          label: "Date Uploaded",
          type: "date",
          maxDate: new Date(),
          required: true,
        },
      ],
    },
  ],
  collection: (patient) => `CareUsers/${patient}/Data`,
  primaryKey: "start",

  defaults: { documents: [], start: "documents" },
};

export const patientsDocumentsSelectors = (patient) =>
  commonSelectors(patientsDocumentsConfig.collection(patient));

export const postprocessPatientsDocuments = (r) => r;

export const validatePatientsDocuments = () => "";

export const queryPatientsDocuments = (patient) => ({
  collection: patientsDocumentsConfig.collection(patient),
  doc: "documents",
});
